<template>
  <div class="s-shop-select__meta">
    <p class="s-copy s-copy--s">{{ legalText }}</p>
  </div>
</template>

<script>
export default {
  computed: {
    legalText(){
      return this.$store.state.wpdata[wpGlobalData.language].translations.slang_other[0].slang_legal;
    },
  },
  data() {
    return {
      wpGlobalData
    };
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Legals.vue